import { createBrowserRouter } from "react-router-dom";
import HomeLayout from "../components/homeLayout/homeLayout";
import Home from "../screens/home/home";
import Pricing from "../screens/pricing/pricing";
import AffiliateProgram from "../screens/affiliateProgram/affiliateProgram";
import Blog from "../screens/blog/blog";
import ContactUs from "../screens/Company/contactUs/contactUs";
import PrivacyPolicy from "../screens/Company/privacyPolicy/privacyPolicy";
import TermsAndCondition from "../screens/Company/termsAndCondition/termsAndCondition";
import LandingPage from "../screens/landingPage/landingPage";
import B2bdatabase from "../screens/Tools/B2BDatabase/B2BDatabase";
import Emailverify from "../screens/Tools/EmailVerifier/emailverifier";
import CompanyInfo from "../screens/Directories/companyInfo";
import SalesAi from "../screens/Tools/SalesAi/salesai";
import FacebookTools from "../screens/Tools/FacebookTools/facebook";
import Emailfinder from "../screens/Tools/EmailFinder/EmailFinder";
const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "pricing",
        element: <Pricing />,
      },
      {
        path: "b2b-prospecting-tool",
        element: <B2bdatabase />,
      },
      {
        path: "email-verifier",
        element: <Emailverify />,
      },
      {
        path: "facebook-tools",
        element: <FacebookTools />,
      },
      {
        path: "email-finder",
        element: <Emailfinder />,
      },
      {
        path: "landing-page",
        element: <Home />,
      },
      {
        path: "affiliate-program",
        element: <AffiliateProgram />,
      },
      {
        path: "business/7fb4ca5e55b22e15",
        element: <CompanyInfo />,
      },
      {
        path: "meet-cara",
        element: <SalesAi />,
      },
      {
        path: "blog",
        element: <Blog />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "terms-condition",
        element: <TermsAndCondition />,
      },
    ],
  },
]);

export default router;
